(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-nutrition-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const opener = event.target.closest('[data-tb-open]');
    const panel = opener && document.getElementById(opener.dataset.tbOpen);
    if (panel?.matches('[data-tb-nutrition]')) {
      const variantId = document.getElementById(panel.dataset.productForm)?.querySelector('[name="id"]')?.value;
      const variants = Array.from(panel.querySelectorAll('[data-nutrition-variant]'));
      const selected = variants.find(item => item.dataset.nutritionVariant === variantId) || variants[0];
      variants.forEach(item => { item.open = false; });
      if (selected) selected.open = true;
      panel.scrollTop = 0;
    }
    const zoom = event.target.closest('[data-nutrition-zoom]');
    if (zoom) {
      const enlarged = zoom.getAttribute('aria-pressed') !== 'true';
      zoom.setAttribute('aria-pressed', String(enlarged));
      zoom.closest('.tb-nutrition-panel__content').classList.toggle('is-enlarged', enlarged);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
